
import { Component, OnInit, untracked } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AccountCtlService, CashoutCtlService } from '../api/services';
import { SessionService } from '../common/session.service';
import { BalanceDto, CashOutDto, PartnerDto, ReceiptMeanDto, UserDto } from '../api/models';
import * as bootstrap from 'bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-cashout',
  
  imports: [
    ReactiveFormsModule,
    NgxPaginationModule
],
  templateUrl: './cashout.component.html',
  styleUrl: './cashout.component.css'
})
export class CashoutComponent implements OnInit {

  pageConfig= {
    itemsPerPage: 20,
    currentPage: 0,
    totalItems: 0
   };

  
  cashoutForm: FormGroup;
  receiptMeanForm: FormGroup;
  
  merchants?:Array<PartnerDto>;
  message:string ='';
  messageColor ='text-success';
  balance?:BalanceDto;
  realBalance?:any;
  availableBalance?:any;
  receiptionMeans:Array<ReceiptMeanDto>=Array.of();
  isAddReceiptMean=false;
  receptionNetwork='';
  isListCashout=false;
  isCashout=false;
  cashouts:any;
  connectedPartner:PartnerDto={name:'',phone:'',address:''};
  connectedUser:UserDto={};
  listCashoutForm:FormGroup;
  currentCashout?:CashOutDto;
 

  constructor( private formBuilder: FormBuilder,
    private session:SessionService,
    private cashoutService:CashoutCtlService,
    private accountService:AccountCtlService
  ){

    this.cashoutForm = this.formBuilder.group({
      amount: ['',[Validators.required,Validators.min(5)]],
      receptionNetwork: ['',Validators.required],
      receptionMean:['',[Validators.required,Validators.minLength(9)]],
      idPartner:['',Validators.required]
    });
    this.receiptMeanForm = this.formBuilder.group({
      idPartner:['',Validators.required],
      receptionNetwork: ['',Validators.required],
      receptionMean:['',[Validators.required,Validators.minLength(9)]],
         });
         this.listCashoutForm = this.formBuilder.group({
          idPartner:['',Validators.required]
          
             });
    

  }
  ngOnInit(): void {
   
    let session=this.session.getSessionInfo();
    this.connectedPartner=session.partner!!;
    this.connectedUser=session;
    if(this.connectedPartner.type =='MERCHANT'){
    
      this.cashoutForm.controls['idPartner'].setValue(this.connectedPartner.id);
      this.receiptMeanForm.controls['idPartner'].setValue(this.connectedPartner.id);
      this.listCashoutForm.controls['idPartner'].setValue(this.connectedPartner.id);
      this.getBalancePartner(this.connectedPartner.id!!);
      if(this.connectedUser.role?.code=='ADMIN_SCHOOL'){
      this.isCashout=true;
    }else {
      this.isCashout=false;
      this.isAddReceiptMean=false;
      this.isListCashout=true;
      this.loadCashouts(this.connectedPartner.id,this.pageConfig.itemsPerPage,0);
    }
    }else {
      this.isListCashout =true;
      this.isAddReceiptMean=false;
      this.isCashout=false;
      this.loadCashouts(undefined,this.pageConfig.itemsPerPage,0);

    }
  }
  
  onSendCashout(){
    let form = this.cashoutForm.value;

    this.cashoutService.cashoutMoney(
       {
        amount:form.amount,
        receiptMean:{
          reference :form.receptionMean,
          mode:{
            code:form.receptionNetwork
          },
          
        }
      }
    ).subscribe({
      next:(resp)=>{
        this.cashoutForm.reset();
        if(resp.status =='FAILED'){
          this.message ='Opération a echoué veuillez reessayer';
          this.messageColor ='text-danger';

        }else if(resp.status =='PENDING'){
          this.message ='Opération en cours de traitement';

        }else{
          this.message ='Opération éffectué avec succés';
        }
        const elt =document.getElementById('createCashout');
         const modAdd = new bootstrap.Modal(elt!!);
         modAdd.show();
      },
      error:(err)=>{
        this.messageColor ='text-danger';
        this.message = err.error.message;
        const elt =document.getElementById('createCashout');
         const modAdd = new bootstrap.Modal(elt!!);
         modAdd.show();

      }
    });
  }
  getBalancePartner(partner:number){

    this.accountService.getBalance(
      undefined,
      partner
    ).subscribe({
      next:(resp)=>{
        this.balance = resp; 
       this.realBalance =  new Intl.NumberFormat('sn-SN', { style: 'currency', currency: 'XOF' }).format(
          this.balance.balance!!,
        );
        this.availableBalance =new Intl.NumberFormat('sn-SN', { style: 'currency', currency: 'XOF' }).format(
          this.balance.availableBalance!!,
        );
        console.log(this.realBalance);   
      },
      error:(err)=>{
       console.log(err.error);
        this.balance = {
          balance: 0,
          availableBalance: 0
        };
       
      }
    });
  }
  abs(amount:number){
    return Math.abs(amount);
  }
  onChangeReceiptMean(){

    let form = this.cashoutForm.value;
    let receptNet = form.receptionNetwork;
    if(receptNet==null || receptNet.length ==0){

      this.cashoutForm.controls['receptionMean'].setValue('');

    }else {
      this.receptionNetwork =receptNet;
      this.cashoutService.getReceiptMeans(
        receptNet,
         form.idPartner
        ).subscribe({
          next:(resp)=>{
            if(resp.length ==0){
              this.message = 'Veuille ajouter un moyen de de reception';
              
              const elt =document.getElementById('createCashout');
              const modAdd = new bootstrap.Modal(elt!!);
              modAdd.show();

            }else {
            this.receiptionMeans =resp;
          }

          },
          error:(err)=>{
            this.messageColor ='text-danger';
            this.message = err.error.message;
            const elt =document.getElementById('createCashout');
            const modAdd = new bootstrap.Modal(elt!!);
            modAdd.show();
          }
        })

    }
  }
  onDisplayAddMean(){
    this.isAddReceiptMean=true;
  }
  onAddReceiptMean(){
    let form =this.receiptMeanForm.value;

    this.cashoutService.addReceiptMean({
      reference:form.receptionMean,
      mode:{
        code:form.receiptNetwork
      },
      partner:{
        id:form.idPartner,
        name:' ',
        phone: ' ',
        address: ' '
      }

    }
  ).subscribe({
    next:(resp)=>{
      this.messageColor ='text-success';
      this.message = 'Votre nouveau moyen de reception est ajouté';
      this.receiptMeanForm.reset();
      this.isAddReceiptMean=false;
      const elt =document.getElementById('createCashout');
      const modAdd = new bootstrap.Modal(elt!!);
      modAdd.show();
    },
    error:(err)=>{
      this.messageColor ='text-danger';
      this.message = err.error.message;
      const elt =document.getElementById('createCashout');
      const modAdd = new bootstrap.Modal(elt!!);
      modAdd.show();
    }
  })
  }
  onNextPage(event:number){
    let form =this.listCashoutForm.value
    this.loadCashouts(form.idPartner, this.pageConfig.itemsPerPage,event-1);

  }
  loadCashouts(idP?:number,pageSize:number=20,pageNumber:number=0){
    this.cashoutService.
    getCashout(
      idP,
      pageSize,
      pageNumber, 
    ).
    subscribe({
      next:(resp)=>{
        this.cashouts=resp;
        this.pageConfig.totalItems = resp.page?.totalElements!!;
        this.pageConfig.currentPage = resp.page?.number!! +1;

      },
      error:(err)=>{
        console.log(err);
        this.messageColor ='text-danger';
      this.message = err.error.message;
      const elt =document.getElementById('createCashout');
      const modAdd = new bootstrap.Modal(elt!!);
      modAdd.show();
      }
    })
  }
  onUpdateCashout(trx:CashOutDto,statusU:'VALIDATED' | 'PAID' | 'PENDING' | 'CANCELED' | 'FAILED'){

    this.cashoutService.updateCashout(
      trx.id!!,
      statusU,
      
    ).subscribe(
      {
        next:(resp)=>{
          console.log(resp);
          this.messageColor ='text-success';
         this.message ='Votre demande est prise en charge avec succés';
         const elt =document.getElementById('createCashout');
          const modAdd = new bootstrap.Modal(elt!!);
          modAdd.show();
          if(this.connectedPartner.type=="MERCHANT"){
            this.loadCashouts(this.connectedPartner.id,this.pageConfig.itemsPerPage,0);
          }else {
            this.loadCashouts(undefined,this.pageConfig.itemsPerPage,0);
          }  
        },
      
      error:(err)=>{
        this.messageColor ='text-danger';
      this.message = err.error.message;
      const elt =document.getElementById('createCashout');
      const modAdd = new bootstrap.Modal(elt!!);
      modAdd.show();
      }
    }
    )

  }
  onDetailsCashout(trx:CashOutDto){
    this.currentCashout=trx;
    const elt =document.getElementById('detailsCashout');
      const modAdd = new bootstrap.Modal(elt!!);
      modAdd.show();

  }
  OnHistoryCashout(){
    this.isCashout=false;
    this.isAddReceiptMean=false;
    this.isListCashout=true;
    let idPartner=this.cashoutForm.value.idPartner;
    this.loadCashouts(idPartner,this.pageConfig.itemsPerPage,0);
  }
  onDisplayCashout(){
    this.isCashout=true;
    this.isAddReceiptMean=false;
    this.isListCashout=false;
  }
}
